<div class="modal-header">
    <h3>{{modalData.modalTitle}}</h3>
</div>
<div class="modal-body">
    <div class="alert" [ngClass]="{'alert-default' : modalData.alertLevel === 'default', 'alert-success' : modalData.alertLevel === 'success', 'alert-danger': modalData.alertLevel === 'danger' }">{{modalData.modalMessage}}</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="cancelClicked()">
        {{closeButtonText}}
    </button>
</div>